<template>
  <div
    v-for="customActionValue in customActionValues"
    :key="customActionValue.customActionId"
  >
    <BListItem class="mb-300">
      <template #header>
        <span>{{ customActionValue.customActionName }}</span>
      </template>
      <span>{{ customActionValue.valueLabel || '-' }}</span>
    </BListItem>
  </div>
</template>

<script lang="ts" setup>
type CustomActionOptionValue = {
  customActionName: string;
  customActionId: number;
  valueLabel: string;
};

type TProps = {
  customActionValues: CustomActionOptionValue[];
};
defineProps<TProps>();
</script>
